import filtresComparaisonApi from '@/api/filtres-comparaison.api'

const getDefaultState = () => {
  return {
    filtresAdherent: {},
    filtresValeursPossibles: {
      regionsAgrial: [],
      typeExploitation: {},
      typeProduction: {},
      potentielSol: {},
      ressourceEffluents: {},
      stockeur: {}
    },
  }
}

const module = {
  namespaced: true,

  state: getDefaultState(),

  getters: {
    filtresAdherent (state) {
      return state.filtresAdherent
    },
    filtresValeursPossibles (state) {
      return state.filtresValeursPossibles
    },
  },
  mutations: {
    SET_FILTRES_ADHERENT (state, filtresAdherent) {
      state.filtresAdherent = filtresAdherent
    },
    SET_VALEURS_TYPE_EXPLOITATION (state, typeExploitations) {
      state.filtresValeursPossibles.typeExploitation = typeExploitations
    },
    SET_VALEURS_TYPE_PRODUCTION (state, typeProductions) {
      state.filtresValeursPossibles.typeProduction = typeProductions
    },
    SET_VALEURS_POTENTIEL_SOL (state, potentielsSols) {
      state.filtresValeursPossibles.potentielSol = potentielsSols
    },
    SET_VALEURS_RESSOURCE_EFFLUENTS (state, ressourcesEffluents) {
      state.filtresValeursPossibles.ressourceEffluents = ressourcesEffluents
    },
    SET_VALEURS_STOCKEUR (state, stockeurs) {
      state.filtresValeursPossibles.stockeur = stockeurs
    },
    SET_VALEURS_REGIONS_AGRIAL (state, regionsAgrial) {
      state.filtresValeursPossibles.regionsAgrial = regionsAgrial
    },
    RESET (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    initFiltres ({ commit, getters, dispatch }, codeRegionNumtiers) {
      return Promise.all([
        dispatch('getValeursTypeExploitation'),
        dispatch('getValeursTypeProduction'),
        dispatch('getValeursPotentielSol'),
        dispatch('getValeursRessourceEffluents'),
        dispatch('getValeursStockeur'),
        dispatch('getValeursRegionsAgrial')
      ]).then(() => {
        const filtresParDefaut = {
          typeExploitation: getters.filtresValeursPossibles.typeExploitation[0],
          typeProduction: getters.filtresValeursPossibles.typeProduction[0],
          potentielSol: getters.filtresValeursPossibles.potentielSol[0],
          ressourceEffluents: getters.filtresValeursPossibles.ressourceEffluents[0],
          stockeur: getters.filtresValeursPossibles.stockeur[0],
          regionsAgrial: [getters.filtresValeursPossibles.regionsAgrial.find(region => region.codeRegion === codeRegionNumtiers)],
        }

        commit('SET_FILTRES_ADHERENT', filtresParDefaut)
      })
    },
    getValeursTypeExploitation ({ commit }) {
      return filtresComparaisonApi.getValeursTypeExploitation()
        .then(result => {
          commit('SET_VALEURS_TYPE_EXPLOITATION', result)
        })
    },
    getValeursTypeProduction ({ commit }) {
      return filtresComparaisonApi.getValeursTypeProduction()
        .then(result => {
          commit('SET_VALEURS_TYPE_PRODUCTION', result)
        })

    },
    getValeursPotentielSol ({ commit }) {
      return filtresComparaisonApi.getValeursPotentielSol()
        .then(result => {
          commit('SET_VALEURS_POTENTIEL_SOL', result)
        })
    },
    getValeursRessourceEffluents ({ commit }) {
      return filtresComparaisonApi.getValeursRessourceEffluents()
        .then(result => {
          commit('SET_VALEURS_RESSOURCE_EFFLUENTS', result)
        })
    },
    getValeursStockeur ({ commit }) {
      return filtresComparaisonApi.getValeursStockeur()
        .then(result => {
          commit('SET_VALEURS_STOCKEUR', result)
        })
    },
    getValeursRegionsAgrial ({ commit }) {
      return filtresComparaisonApi.getValeursRegionsAgrial()
        .then(result => {
          commit('SET_VALEURS_REGIONS_AGRIAL', result)
        })

    },

    setFiltres ({ commit }, filtresComparaison) {
      return commit('SET_FILTRES_ADHERENT', filtresComparaison)
    },
    reset ({ commit }) {
      commit('RESET')
    }
  }
}

export default module
